import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import qs from 'qs'

import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import CruiseDepartureFromDropdown, { DEPARTURE_OPTIONS } from './CruiseDepartureFromDropdown'

import { getThemeClassName } from 'lib/theme/themeUtils'
import { CRUISE_BANK_OFFERS_FILTERS } from 'constants/cruise'
import useOfferList from 'hooks/Offers/useOfferList'
import { useAppSelector } from 'hooks/reduxHooks'

const AU_DEFAULT_DEPARTURE = DEPARTURE_OPTIONS[0]
const NZ_DEFAULT_DEPARTURE = DEPARTURE_OPTIONS[1]
const getDefaultDeparture = (regionCode: string) => regionCode === 'NZ' ? NZ_DEFAULT_DEPARTURE : AU_DEFAULT_DEPARTURE

function CruisePageDepartureFromCarousel() {
  const intl = useIntl()
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)
  const [departure, setDeparture] = useState<App.SearchDeparturePort>(() => getDefaultDeparture(currentRegionCode))

  useEffect(() => {
    setDeparture(getDefaultDeparture(currentRegionCode))
  }, [currentRegionCode])

  const filters: App.OfferListFilters = {
    departureIds: [departure.value],
    departureNames: [departure.format.mainText],
  }

  const offerList = useOfferList({
    ...CRUISE_BANK_OFFERS_FILTERS,
    ...filters,
  })

  const queryString = qs.stringify(filters, { arrayFormat: 'repeat' })

  const cruisesDepartingFromLabel = intl.formatMessage({
    id: 'JDSeO_R2CIBFs2i_5FXY',
    defaultMessage: 'Cruises departing from',
    description: 'Heading for cruise offers departing from a selected port',
  })

  const viewAllLabel = intl.formatMessage({
    id: '2Y_pWWFHrhIYNGyvDHz8',
    defaultMessage: 'View all',
    description: 'Button text to view all cruise offers from a departure port',
  })

  return (
    <Group gap={32} direction="vertical">
      <LayoutContainer>
        <Group gap={16} direction="horizontal" horizontalAlign="space-between">
          <Group gap={4} direction="vertical" tabletDirection="horizontal" tabletGap={16}>
            <Heading variant="heading2">{cruisesDepartingFromLabel}</Heading>
            <CruiseDepartureFromDropdown departure={departure} onChange={setDeparture} />
          </Group>

          <TextButton
            kind="tertiary"
            variant="dark"
            to={`/search/cruises?${queryString}`}
          >
            {viewAllLabel}
          </TextButton>
        </Group>
      </LayoutContainer>

      <OfferListCarousel
        tileStyle="card-default"
        tileSize="medium"
        overrideOfferList={offerList}
        className={getThemeClassName({ desktop: 'default' })}
      />
    </Group>
  )
}

export default CruisePageDepartureFromCarousel
